<div class="sectionb">


<mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
<app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
<ng-container *ngIf="!ismodal">
    <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2">
        <span class="navbar-brand mb-0 h1"> <i class="fas fa-dice-d6"></i> Site Detailed Info</span>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div class="navbar-nav ml-auto">
                <button *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}" matTooltip="Save site basic data" type="button" class="btn btn-sm  btn-success "
                    (click)="saveModel()">
                    <i class="far fa-save"></i> Save
                </button>
            </div>
        </div>
    </nav>
</ng-container>
    <div class="container-fluid htmleditor" style="    min-height: 300px;">
        <ckeditor [(ngModel)]="data" [editor]="ckeditor"  [config]="ckconfig"></ckeditor>
    </div>
    <!-- [config]="ckconfig" -->
</div>